"use strict";

exports.__esModule = true;
exports.whoami = exports.tracker = void 0;

var _tagManager = require("./modules/tag-manager");

var _dataLayerComposer = require("./modules/data-layer-composer");

var _glitrTracker = require("./modules/glitr-tracker");

var _events = _interopRequireDefault(require("./trackingCalls/events"));

var _pageView = _interopRequireDefault(require("./trackingCalls/pageView"));

var _messages = _interopRequireDefault(require("./messages"));

var _whoami = require("./modules/whoami");

var _dataFormatter = require("./helpers/dataFormatter");

var _setDebugMode = require("./helpers/setDebugMode");

var _detectTestMode = require("./helpers/detectTestMode");

var _gtmHelper = require("./helpers/gtmHelper");

var _tealiumHelper = require("./helpers/tealiumHelper");

var _detectTagmanager = require("./helpers/detectTagmanager");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This is the main function that initialises the tracker.
 *
 * @todo allow for more than one tagmanager
 * @todo separate configuration file logic from tracker and fetch async
 * @todo enhance configuration logic
 * @todo abstract tagmanager logic
 * @todo make async
 *
 * @param {*} [bootstrapConfig=undefined]
 * @returns GLiTR tracking object with push method, tracking call definitions, datalayer, whoami
 */
const tracker = (bootstrapConfig = undefined) => {
  let glitrTracker;
  let tagManager;
  let pushQueue = [];

  let push = element => {
    pushQueue.push(element);
    return Promise.resolve();
  };

  let whoami;
  let dataLayer;
  let returnObject = {
    whoami,
    dataLayer,
    customTracker: glitrTracker,
    push,
    trackingCalls: {
      pageview: _pageView.default,
      ..._events.default
    },
    messages: _messages.default
  };

  const initialiseTracker = () => (0, _whoami.loadConfig)(bootstrapConfig.entity, bootstrapConfig.brandCode, bootstrapConfig.environment).then(result => {
    whoami = result;
    const debug = (0, _setDebugMode.setDebugMode)(whoami.debugEnabled); // MHBE enableTestMode is part of the glitrTracker
    // MHLU has no glitrTracker 
    // >> move enableTestMode up in the config file
    // >> adjust code to check for both cases
    // >> TO DO: to one code base (MHLUX version)

    const enableTestMode = whoami.enableTestMode ? whoami.enableTestMode : whoami.glitrTracker ? whoami.glitrTracker.enableTestMode : false;
    const mhLogger = debug ? console.log : () => {};
    mhLogger('Debug enabled', debug);
    mhLogger('result', debug);
    dataLayer = (0, _dataLayerComposer.composeDataLayer)(whoami); // this breaks the reference to the global-scoped object

    const localQueue = [...pushQueue];
    const tagManagerQueue = [];

    if (whoami.glitrTracker) {
      glitrTracker = new _glitrTracker.GlitrTracker(whoami, dataLayer, mhLogger);
    }

    if (whoami.tagManager) {
      //to do refactor for all tag managers
      if (!(0, _detectTestMode.detectTestMode)(enableTestMode)) {
        (0, _tagManager.initializeTagManager)(whoami.tagManager).then(result => {
          tagManager = result;

          if ((0, _detectTagmanager.tagManagerIsTealium)(whoami)) {
            mhLogger('tagManager is Tealium');
            let i = 0;
            const firePageView = setInterval(function () {
              i++;
              utag_data.initCounter = i;
              mhLogger('checked ', i, ' times to see if tealium is ready');

              if (i > 200) {
                clearInterval(firePageView);
                utag_data.initFinished = true;
              }

              if (window.utag && utag.handler && utag.handler.iflag == 1) {
                clearInterval(firePageView);
                mhLogger('TEALIUM finished tag mgr init TEALIUM');
                utag_data.initFinished = true;
                (0, _tealiumHelper.processTagManagerQueueForTealium)(tagManager, tagManagerQueue);
              }
            }, 250);
          }

          if ((0, _detectTagmanager.tagManagerIsGtm)(whoami)) {
            mhLogger('tagManager is GTM');
            let i = 0;
            const firePageView = setInterval(function () {
              i++;
              dataLayer.initCounter = i;
              mhLogger('checked ', i, ' times to see if gtm is ready');

              if (i > 200) {
                clearInterval(firePageView);
                dataLayer.initFinished = true;
              }

              if (window.dataLayer) {
                mhLogger('GTM finished tag mgr init GTM');
                clearInterval(firePageView);
                dataLayer.initFinished = true;
                (0, _gtmHelper.processTagManagerQueueForGtm)(tagManager, tagManagerQueue);
              }
            }, 250);
          }

          return result;
        }).catch(error => {
          // console.log('ERROR ', error);
          throw new Error('Failed to initialise tag manager');
        });
      }
    }

    push = (event, trackerSources = []) => {
      let eventSent = false;
      mhLogger('dataLayer in push', dataLayer);

      if (event.type === 'enrich') {
        (whoami.allowedPropertiesForEnrichment || []).forEach(key => {
          dataLayer[key] = event.data[key];
          mhLogger('dataLayer after enrichment', dataLayer);
        });
        return Promise.resolve();
      }

      if (event.type === 'cleanUpEnrichedParameters') {
        (whoami.allowedPropertiesForEnrichment || []).forEach(key => {
          dataLayer[key] = null;
          mhLogger('dataLayer after cleanup enrichment', dataLayer);
        });
        return Promise.resolve();
      }

      const preparedEvent = (0, _dataFormatter.dataFormatter)(event);

      if (trackerSources.length === 0 || trackerSources.find(src => src === 'tagmanager')) {
        if (tagManager) {
          if ((0, _detectTagmanager.tagManagerIsTealium)(whoami)) {
            mhLogger('Tagmanager is Tealium');
            eventSent = true;

            if (preparedEvent.type === 'pageview') {
              mhLogger('Tealium sending pageview');
              utag.view({ ...utag_data,
                ...dataLayer
              });
            }

            if (preparedEvent.type === 'event') {
              mhLogger('Tealium sending event');
              let tealiumEvent = (0, _tealiumHelper.tealiumFormatter)(dataLayer, preparedEvent);
              utag.link({ ...tealiumEvent
              });
            }
          }

          if ((0, _detectTagmanager.tagManagerIsGtm)(whoami)) {
            mhLogger('Tagmanager is GTM');
            eventSent = true;

            if (preparedEvent.type === 'pageview') {
              mhLogger('GTM sending pageview');
              window.dataLayer.push({ ...dataLayer,
                event: preparedEvent.type,
                identityaccountid: preparedEvent.identityaccountid
              });
            }

            if (preparedEvent.type === 'event') {
              mhLogger('GTM sending event');
              let gtmEvent = (0, _gtmHelper.gtmFormatter)(dataLayer, preparedEvent);
              window.dataLayer.push({ ...gtmEvent
              });
            }
          }
        } else if (whoami.tagManager) {
          tagManagerQueue.push(preparedEvent);
        }
      }

      if (glitrTracker && (trackerSources.length === 0 || trackerSources.find(src => src === 'glitr'))) {
        mhLogger('GLiTR tracker push event');
        eventSent = true;

        if (preparedEvent.event !== 'product_view' && preparedEvent.event !== 'product_click' && preparedEvent.event !== 'checkout' && preparedEvent.event !== 'checkout_option' && preparedEvent.event !== 'purchase' && preparedEvent.event !== 'ecommerce_clear') {
          glitrTracker.push(preparedEvent);
        }
      }

      if (eventSent) {
        return Promise.resolve(true);
      }

      return (0, _detectTestMode.detectTestMode)(enableTestMode) ? Promise.resolve() : Promise.reject(new Error('No tracker found'));
    }; //process local queue


    if (localQueue.length > 0) {
      localQueue.map(event => push(event));
    }

    returnObject.push = push;
    returnObject.whoami = whoami;
    returnObject.dataLayer = dataLayer;
  });

  initialiseTracker();
  return {
    whoami: returnObject.whoami,
    dataLayer: returnObject.dataLayer,
    push: (...args) => returnObject.push(...args),
    trackingCalls: {
      pageview: _pageView.default,
      ..._events.default
    },
    messages: _messages.default
  };
};

exports.tracker = tracker;
const whoami = _whoami.loadConfig;
exports.whoami = whoami;